import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class InvestorService {

  constructor(private httpClient: HttpClient) {}

  getProfileDataById() {
   //const url = '../../../assets/json/profileNew.json';
   const url = environment.profileServiceGet;
    return this.httpClient.get(url).pipe(catchError((err: Response) => this.handleError(err)));
  }

  getHeader() {
    //const url = '../../../assets/json/header.json';
    const url = environment.taxFormsHeader;
    return this.httpClient.get(url).pipe(catchError((err: Response) => this.handleError(err)));
  }

  getTaxForm() {
    //const url = '../../../assets/json/taxForm.json';
    const url = environment.uploadTaxForm;
    return this.httpClient.get(url).pipe(catchError((err: Response) => this.handleError(err)));
  }

  getForm15(formName:string,cycleYear,cycleName){
      //let url = '../../../assets/json/form15.json';
      let url = environment.onlineFormServiceGet;
      url = url+ '/'+ formName+'/'+cycleYear+'/'+cycleName;
    return this.httpClient.get(url).pipe(catchError((err: Response) => this.handleError(err)));
  }

  getContry(){
   //const url = '../../../assets/json/contry.json';
    const url = environment.countryList;
    return this.httpClient.get(url).pipe(catchError((err: Response) => this.handleError(err)));
  }

  postProfileData(inputModel:object){
    const url=environment.profileServicePost;
    return this.httpClient.post(url,inputModel).pipe(catchError((err: Response) => this.handleError(err)));
  }


  //upload to azure
  postFormDocument(inputModel:object){
    const url=environment.uploadDocumentForm;
    return this.httpClient.post(url,inputModel).pipe(catchError((err: Response) => this.handleError(err)));
  }

  uploadForm(inputModel:object){
    const url=environment.onlineFormServicePost;
    return this.httpClient.post(url,inputModel).pipe(catchError((err: Response) => this.handleError(err)));
  }

  saveDPConsent(inputModel:object){
       //const url = '../../../assets/json/postDP.json';
       //return this.httpClient.get(url).pipe(catchError((err: Response) => this.handleError(err)));
       // console.log("saveDPConsent",inputModel)
      const url=environment.saveDpConsent;
      return this.httpClient.post(url,inputModel).pipe(catchError((err: Response) => this.handleError(err)));
  }
  getDPDetails() {
     //const url = '../../../assets/json/getDP.json'; 
     const url=environment.getUserAcceptance;
    return this.httpClient.get(url).pipe(catchError((err: Response) => this.handleError(err)));
}
getAllDocByType(docType,cycleYear,cycleName) {
  // const url = '../../../assets/json/getalldocs.json';    
       let url = environment.getAllDocByType;
       url = url+ '/'+ docType+'/'+cycleYear+'/'+cycleName;
  return this.httpClient.get(url).pipe(catchError((err: Response) => this.handleError(err)));
}
downloadFile(docName) {
  // const url = '../../../assets/json/downloadFile.json';    
       let url = environment.downloadFile;
     url = url+ '/'+ docName;
  return this.httpClient.get(url).pipe(catchError((err: Response) => this.handleError(err)));
}
downloadTDSFile(input){
  //const url = '../../../assets/json/postDelete.json';    
  let url = environment.downloadFileTDS;  
  return this.httpClient.post(url,input).pipe(catchError((err: Response) => this.handleError(err)));
}
deleteFileFromAzure(docName){
  //const url = '../../../assets/json/postDelete.json';    
  let url = environment.deleteFile;
   url = url+ '/'+ docName;
  return this.httpClient.post(url,'').pipe(catchError((err: Response) => this.handleError(err)));
}

// getAllDocByTypeAfterDeletion(docType) {
//   const url = '../../../assets/json/getalldocsafterDeletion.json';    
//    //   let url = environment.getAllDocByType;
//    //   url = url+ '/'+ docType;
//  return this.httpClient.get(url).pipe(catchError((err: Response) => this.handleError(err)));
// }
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
